export enum UserBonusQueryKeys {
  Primary = '/user-bonus',
  ById = '/user-bonus/:id',
}
